import { Injectable, Inject, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { of } from 'rxjs/observable/of';
import { CookieService } from 'ngx-cookie-service';
import isEmpty from 'lodash-es/isEmpty';
import { CommonModule } from '@angular/common';

class GeolocationService {
    constructor(geoLocationConfig, httpClient, activatedRoute, cookieService) {
        this.geoLocationConfig = geoLocationConfig;
        this.httpClient = httpClient;
        this.activatedRoute = activatedRoute;
        this.cookieService = cookieService;
        this.url = this.geoLocationConfig.GEO_CODE_URL;
        this.activatedRoute.queryParams
            .subscribe(params => {
            this.activate(params);
        });
    }
    activate(params) {
        this.ipOverride = params.ipoverride;
    }
    getGeoCode(options) {
        const cookie = this.cookieService.get(this.geoLocationConfig.GEO_CODE_COOKIE_NAME);
        if (isEmpty(cookie) || options.forceRefresh) {
            if (this.ipOverride) {
                this.url = `${this.geoLocationConfig.GEO_CODE_URL}?ipoverride=${this.ipOverride}`;
            }
            return this.httpClient.get(this.url);
        }
        else {
            return this.getGeoFromCookie(cookie);
        }
    }
    getGeoFromCookie(cookie) {
        let geoip;
        const decodedString = atob(cookie);
        geoip = JSON.parse(decodedString);
        return of(geoip);
    }
    clearGeolocationCookie(path, domain) {
        this.cookieService.delete(this.geoLocationConfig.GEO_CODE_COOKIE_NAME, path, domain);
    }
}
GeolocationService.decorators = [
    { type: Injectable }
];
GeolocationService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['GEO_LOCATION_CONFIG',] }] },
    { type: HttpClient },
    { type: ActivatedRoute },
    { type: CookieService }
];

class GeolocationComponent {
    constructor(_geolocationService) {
        this._geolocationService = _geolocationService;
        this.title = 'WDPR Angular Geolocation';
        this.change = new EventEmitter();
    }
    ngOnInit() {
        this.subscribe();
    }
    subscribe() {
        this._geolocationService.getGeoCode({ forceRefresh: false })
            .subscribe(data => {
            this.geoLocation = data;
            this.change.emit(data);
        });
    }
}
GeolocationComponent.decorators = [
    { type: Component, args: [{
                // tslint:disable-next-line:component-selector
                selector: 'wdpr-ra-angular-geolocation',
                template: ``
            },] }
];
GeolocationComponent.ctorParameters = () => [
    { type: GeolocationService }
];
GeolocationComponent.propDecorators = {
    geoLocation: [{ type: Input }],
    change: [{ type: Output }]
};

class GeolocationModule {
    static configure(config) {
        return {
            ngModule: GeolocationModule,
            providers: [{
                    provide: 'GEO_LOCATION_CONFIG',
                    useValue: config || {
                        GEO_CODE_URL: '/api/v1/geocode',
                        GEO_CODE_COOKIE_NAME: 'latestWDPROGeoIP'
                    }
                }]
        };
    }
}
GeolocationModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, RouterModule],
                providers: [
                    CookieService,
                    GeolocationService
                ],
                declarations: [GeolocationComponent],
                exports: [GeolocationComponent]
            },] }
];

/*
 * Public API Surface of ra-angular-geolocation
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GeolocationComponent, GeolocationModule, GeolocationService };
//# sourceMappingURL=wdpr-ra-angular-geolocation.js.map
